import { render, staticRenderFns } from "./NewUiServiceDropdown.vue?vue&type=template&id=630bfb54&scoped=true&"
import script from "./NewUiServiceDropdown.vue?vue&type=script&lang=ts&"
export * from "./NewUiServiceDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NewUiServiceDropdown.vue?vue&type=style&index=0&id=630bfb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630bfb54",
  null
  
)

export default component.exports